import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useFormSubmissionListQuery } from '../hooks'
import { Card, Page, PageHeader, DataTable } from 'components'

const COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id'
  },
  {
    Header: 'Setor da Entidade',
    accessor: 'user.entity.sector.name'
  },
  {
    Header: 'Data Submissão',
    accessor: data => new Date(data?.dateCreated).toLocaleString()
  },
  {
    Header: 'Score',
    accessor: data => (data?.score * 100)?.toFixed(0)
  }
]

export const FormSubmissionListPage = () => {
  const navigate = useNavigate()
  const {
    data,
    error,
    loading,
    pageSize,
    pageIndex,
    fetchPage,
    setPageSize
  } = useFormSubmissionListQuery()

  const onRowClick = row => navigate(`${row.original.id}`)

  if (error) {
    return navigate('/login')
  }

  const pageCount = Math.ceil(data?.formSubmissionList?.totalCount / pageSize)

  return (
    <Page>
      <PageHeader heading='Relatórios' onBack={() => navigate('..')} />

      <Card p={3}>
        <DataTable
          columns={COLUMNS}
          loading={loading}
          data={data?.formSubmissionList?.results}
          onRowClick={onRowClick}
          onPage={fetchPage}
          onPageSize={setPageSize}
          pageIndex={pageIndex}
          pageCount={pageCount}
        />
      </Card>
    </Page>
  )
}

export default FormSubmissionListPage
